import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedSettlementsAbroad, updateAtmedSettlementsAbroad,
} from '../../../store/actions';
import Settlements from './settlements';

const mapStateToProps = ({ vendorEquipmentReducer }) => ({
  vendorEquipment: vendorEquipmentReducer.vendorEquipment,
  updateVendorEquipmentSuccess: vendorEquipmentReducer.updateVendorEquipmentSuccess
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedSettlementsAbroad,
    updateAtmedSettlementsAbroad,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Settlements);
